var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientsIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6673 4.50002H12.8081C12.4073 4.50002 12.2069 4.50002 12.018 4.44281C11.829 4.3856 11.6623 4.27445 11.3289 4.05215C10.8287 3.71871 10.2581 3.33832 9.97465 3.2525C9.69125 3.16669 9.39065 3.16669 8.78952 3.16669C7.97205 3.16669 7.44512 3.16669 7.07758 3.31893C6.71005 3.47117 6.42102 3.7602 5.84296 4.33826L5.33424 4.84698C5.20397 4.97725 5.13883 5.04239 5.09862 5.1067C4.94955 5.34509 4.96607 5.65139 5.13991 5.87236C5.18681 5.93197 5.25858 5.98973 5.4021 6.10523C5.93262 6.53218 6.69745 6.48957 7.17785 6.0063L8.00065 5.17859H8.66732L12.6673 9.2024C13.0355 9.5728 13.0355 10.1733 12.6673 10.5437C12.2991 10.9141 11.7022 10.9141 11.334 10.5437L11.0007 10.2083M11.0007 10.2083L9.00065 8.19647M11.0007 10.2083C11.3689 10.5787 11.3689 11.1793 11.0007 11.5496C10.6325 11.92 10.0355 11.92 9.66732 11.5496L9.00065 10.879M9.00065 10.879C9.36885 11.2493 9.36885 11.8499 9.00065 12.2203C8.63245 12.5906 8.03552 12.5906 7.66732 12.2203L6.66732 11.2143M9.00065 10.879L7.66732 9.54567M6.66732 11.2143L6.33398 10.879M6.66732 11.2143C7.03552 11.5847 7.03552 12.1852 6.66732 12.5556C6.29913 12.9259 5.70218 12.9259 5.33398 12.5556L3.45156 10.6339C3.06475 10.2391 2.87134 10.0417 2.62355 9.93747C2.37576 9.83333 2.09937 9.83333 1.54661 9.83333H1.33398",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 9.83334H13",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66732 4.50003H1.33398",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsIc);
export default __webpack_public_path__ + "static/media/clients_ic.b8bb743dffcb0071367fad6e145a4c76.svg";
export { ForwardRef as ReactComponent };